
<h2 mat-dialog-title>Comment From: {{ data.title }} <br> {{data.email}} &#64; {{data.date | date:'short'}}</h2>
<mat-dialog-content class="mat-typography">
  <blockquote>
    {{ data.body }}
  </blockquote>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" color="primary">Dismiss</button>
  <a mat-flat-button color="primary" href="mailto:{{data.email}}" cdkFocusInitial [mat-dialog-close]="true" >
    <mat-icon>reply</mat-icon> Reply
  </a>
</mat-dialog-actions>
